module.exports = __webpack_public_path__ + "img/contacts.46e97e75.png";